import { Link } from 'react-router-dom';
import { hobbyData } from '../../content/hobbies';
import { HobbyMediaIcon } from '../../content/hobbyMedia';

export { hobbyData };
/**
 * Renders the hobby sidebar experience.
 *
 * @param {object} props - Component properties.
 * @param {*} props.activeId - Whether active id is enabled.
 * @returns {JSX.Element} The rendered interface.
 */
export default function HobbySidebar({ activeId }) {
  return (
    <aside className="hobbies-sidebar">
      {hobbyData.map((hobby) => (
        <Link
          key={hobby.id}
          className={`hobby-selector ${activeId === hobby.id ? 'active' : ''}`}
          style={{ '--hobby-theme': hobby.theme }}
          to={`/hobby/${hobby.id}`}
        >
          <span className="selector-icon"><HobbyMediaIcon type={hobby.id} /></span>
          <span className="selector-name">{hobby.name}</span>
        </Link>
      ))}
    </aside>
  );
}
